import { render, staticRenderFns } from "./NewSidebarItem.vue?vue&type=template&id=0195990d&scoped=true"
import script from "./NewSidebarItem.vue?vue&type=script&lang=ts"
export * from "./NewSidebarItem.vue?vue&type=script&lang=ts"
import style0 from "./NewSidebarItem.vue?vue&type=style&index=0&id=0195990d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0195990d",
  null
  
)

export default component.exports